<app-client-navbar></app-client-navbar>

<main class="app-main">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

<div id="snackbar">
  <button class="close" (click)="closeSnackbar()">x</button>
  {{
    configService.currentLocale == "en"
      ? "Happy CNY! Please note that the trade-in payment may have a delay during CNY holiday. The payment will be settled after 1 Feb 2023"
      : "新年快樂！請注意，在春節假期期間，Trade-in付款可能會有所延遲，2月1日後陸續發放"
  }}
</div>
